import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  return useDataValue({
    context: 'professional',
    viewPath: props.viewPath,
  })
}
